import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  questionData: {
    question: null,
    loading: false,
    errors: null,
    scoreDetailsPopup: false,
  },
  retakeStatus: {
    loading: false,
    success: false,
    error: null,
  },
  scoreDetails: {
    loading: false,
    data: null,
    error: null,
  },
};

const internaluserSlice = createSlice({
  name: 'internalUser',
  initialState,
  reducers: {
    // Self Assessment Fetch
    getInternalEvaluationAction: (state) => {
      state.questionData.loading = true;
    },
    getInternalEvaluationSuccessAction: (state, action) => {
      state.questionData.question = action.payload;
      state.questionData.loading = false;
    },
    getInternalEvaluationFailureAction: (state, action) => {
      state.questionData.errors = action.payload;
      state.questionData.loading = false;
    },

    // Retake Assessment Actions
    retakeAssessmentAction: (state) => {
      state.retakeStatus.loading = true;
      state.retakeStatus.success = false;
      state.retakeStatus.error = null;
    },
    retakeAssessmentSuccessAction: (state) => {
      state.retakeStatus.loading = false;
      state.retakeStatus.success = true;
    },
    retakeAssessmentFailureAction: (state, action) => {
      state.retakeStatus.loading = false;
      state.retakeStatus.error = action.payload;
    },
    toggleScoreDetailsPopup: (state, action) => {
      state.questionData.scoreDetailsPopup = action.payload; // true or false
    },

    // Score Details Fetch
    getScoreDetailsAction: (state) => {
      state.scoreDetails.loading = true;
      state.scoreDetails.error = null;
      state.scoreDetails.data = null;
    },
    getScoreDetailsSuccessAction: (state, action) => {
      state.scoreDetails.loading = false;
      state.scoreDetails.data = action.payload;
    },
    getScoreDetailsFailureAction: (state, action) => {
      state.scoreDetails.loading = false;
      state.scoreDetails.error = action.payload;
    },

    setInternalUserAssessmentAction: (state) => {
      state.questionData.loading = true;
    },
    setInternalUserAssessmentSuccessAction: (state, action) => {
      state.questionData.loading = false;
    },
    setInternalUserAssessmentFailureAction: (state, action) => {
      state.questionData.loading = false;
      state.questionData.errors = action.payload;
    },
  },
});



export const {
  getInternalEvaluationAction,
  getInternalEvaluationSuccessAction,
  getInternalEvaluationFailureAction,
  retakeAssessmentAction,
  retakeAssessmentSuccessAction,
  retakeAssessmentFailureAction,
  toggleScoreDetailsPopup,
  getScoreDetailsAction,
  getScoreDetailsSuccessAction,
  getScoreDetailsFailureAction,
  setInternalUserAssessmentAction, 
  setInternalUserAssessmentSuccessAction, 
  setInternalUserAssessmentFailureAction,
} = internaluserSlice.actions;

export default internaluserSlice.reducer;